import styled from 'styled-components';
import { gray10, white } from '@spotify-internal/encore-foundation';
import { zIndexDialog } from "../../styles";

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.dialogFullScreen === 'dark';
};

export default styled.main.withConfig({
  displayName: "Container",
  componentId: "sc-707yz5-0"
})(["background:", ";display:flex;flex-direction:column;height:100%;left:0;position:fixed;top:0;width:100%;z-index:", ";"], function (props) {
  return isDarkTheme(props) ? gray10 : white;
}, zIndexDialog);